import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authMethods } from '../components/authMethods';

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [inputs, setInputs] = useState({ email: '', password: '', firstName: '', lastName: '' });
  const [errors, setErrors] = useState([]);
  const [token, setToken] = useState(sessionStorage.getItem('token'));
  const [myUser, setMyUser] = useState(null);
  const [userAuth, setUserAuth] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userDetails, setUserDetails] = useState({ userID: '', userName: '', department: '' });
  const history = useNavigate();

  useEffect(() => {
    if (token) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, [token]);

  const handleSignup = () => {
    authMethods.signup(
      inputs.email,
      inputs.password,
      inputs.firstName,
      inputs.lastName,
      setErrors,
      setToken,
      setMyUser,
      setUserDetails,
      userDetails
    );
    if (myUser) {
      history.push('/cart');
    }
  };

  const handleLogin = () => {
    authMethods.signin(
      inputs.email,
      inputs.password,
      setErrors,
      setMyUser,
      setUserDetails,
      userDetails
    );
  };

  const handleSignout = () => {
    authMethods.signout(setErrors, setToken, setMyUser);
  };

  const handleAuth = () => {
    authMethods.checkAuth(setUserAuth);
  };

  return (
    <AuthContext.Provider
      value={{
        handleSignup,
        handleLogin,
        inputs,
        setInputs,
        errors,
        handleSignout,
        myUser,
        handleAuth,
        userDetails,
        isAuthenticated,
        setIsAuthenticated
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);
